/* Quick diamond search — parses what a shopper types ("2ct oval", "round D VS1")
   into the filters the search page already understands, then sends them there.

   Deliberately front-end only: no new endpoint, no backend change. It reuses
   /pages/search-diamonds and its existing query-string contract, so anything the
   search page can filter, this box can reach.

   Carat bands mirror CARAT_BANDS in src/matcher/groups.ts — typing "2ct" must
   land on the same range the catalogue uses (2.00–2.99), not an arbitrary window. */
(function () {
  var SHAPES = ['round','oval','emerald','pear','princess','cushion','radiant','asscher','marquise','heart'];
  // Italian/Swedish spellings shoppers actually type.
  var SHAPE_ALIAS = {
    tondo:'round', ovale:'oval', smeraldo:'emerald', goccia:'pear', cuore:'heart',
    marquis:'marquise', rund:'round', hjarta:'heart', smaragd:'emerald'
  };
  var CLARITIES = ['fl','if','vvs1','vvs2','vs1','vs2','si1','si2'];
  var COLORS = ['d','e','f','g','h','i','j','k','l','m','n'];
  var BANDS = [
    [0.4,0.40,0.49],[0.5,0.50,0.59],[0.6,0.60,0.69],[0.7,0.70,0.79],
    [0.8,0.80,0.89],[0.9,0.90,0.99],[1.0,1.00,1.19],[1.2,1.20,1.49],
    [1.5,1.50,1.99],[2.0,2.00,2.99],[3.0,3.00,3.49]
  ];

  function bandFor(n) {
    for (var i = 0; i < BANDS.length; i++) if (n >= BANDS[i][1] && n <= BANDS[i][2]) return BANDS[i];
    return null;
  }

  function parse(raw) {
    var q = String(raw || '').toLowerCase().trim();
    if (!q) return null;
    var out = {};

    // carat: "2ct", "1.5 ct", "0,9 carat", "2 carati"
    var m = q.match(/(\d+(?:[.,]\d+)?)\s*(?:ct\b|carat[oi]?\b|karat\b)/);
    if (m) {
      var n = parseFloat(m[1].replace(',', '.'));
      var b = bandFor(n);
      if (b) { out.caratMin = b[1]; out.caratMax = b[2]; }
      else if (isFinite(n)) { out.caratMin = n; out.caratMax = +(n * 1.1).toFixed(2); }
      q = q.replace(m[0], ' ');
    }

    var tokens = q.split(/[^a-z0-9.]+/).filter(Boolean);
    var shapes = [], clarities = [], colors = [];

    tokens.forEach(function (t) {
      var s = SHAPE_ALIAS[t] || t;
      if (SHAPES.indexOf(s) > -1) { if (shapes.indexOf(s) < 0) shapes.push(s); return; }
      if (CLARITIES.indexOf(t) > -1) { if (clarities.indexOf(t) < 0) clarities.push(t); return; }
      // a bare single letter is a colour grade ("round D VS1")
      if (t.length === 1 && COLORS.indexOf(t) > -1) { if (colors.indexOf(t) < 0) colors.push(t); return; }
    });

    if (shapes.length) out.shape = shapes.map(function (s) { return s.toUpperCase(); }).join(',');
    if (clarities.length) out.clarity = clarities.map(function (s) { return s.toUpperCase(); }).join(',');
    if (colors.length) out.color = colors.map(function (s) { return s.toUpperCase(); }).join(',');

    return Object.keys(out).length ? out : null;
  }

  function submit(input) {
    var target = input.getAttribute('data-target') || '/pages/search-diamonds';
    var parsed = parse(input.value);
    var params = new URLSearchParams(parsed || {});
    // Nothing recognised → still send them to the search page rather than a dead
    // end; the full filter panel is right there.
    window.location.href = target + (params.toString() ? '?' + params.toString() : '');
  }

  function init(form) {
    var input = form.querySelector('[data-qs-input]');
    if (!input) return;
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(input); });
    form.querySelectorAll('[data-qs-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.getAttribute('data-qs-chip');
        submit(input);
      });
    });
  }

  function boot() { document.querySelectorAll('[data-quick-search]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
